import { registerTabHandler } from './utils/TabHandler';
import { TabType, } from './store/schema/TabViewState';
import findTabByData from './utils/findTabByData';
import getActiveTab from './utils/getActiveTab';
import { getStore, primaryTab } from './store/tabStore';
import { LazyAction, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "TabView" */ './lazyIndex');
});
export var lazyActivateTab = new LazyAction(lazyModule, function (m) { return m.activateTab; });
export var lazyAddTab = new LazyAction(lazyModule, function (m) { return m.addTab; });
export var lazyCloseTab = new LazyAction(lazyModule, function (m) { return m.closeTab; });
export var lazySetTabIsShown = new LazyAction(lazyModule, function (m) { return m.setTabIsShown; });
export { TabType, findTabByData, getActiveTab, getStore, primaryTab, registerTabHandler, };
//# sourceMappingURL=index.js.map